module.exports = __webpack_public_path__ + "static/media/IconCopy_Light.f16a62bf.svg";